import { ethers } from "ethers";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import { getHashType } from "../services/utils";

const HeroSection = () => {
    const navigate = useNavigate();
    const [searchValue, setSearchValue] = useState("");
    const [isAddress, setIsAddress] = useState(false);
    // Event handler to update the searchValue state
    const handleChange = (event) => {
        setSearchValue(event.target.value);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            if (ethers.isAddress(searchValue)) {
                navigate(`/wallet/${searchValue}`);
            } else if (ethers.isHexString(searchValue, 32)) {
                const type = await getHashType(searchValue);
                if (type === "transaction") {
                    navigate(`/tx/${searchValue}`);
                } else {
                    navigate(`/block/${searchValue}`);
                }
            }
        } catch (error) {
            console.log(error);
        }
    };
    return (
        <>
            <div className="relative z-50">
                <Navbar />
            </div>
            <img
                src="https://miro.medium.com/v2/resize:fit:1400/0*hQlst1ot8TIsT0LC"
                alt="Header"
                className="w-full object-cover h-[30%] absolute -z-30"
            />
            <div className="text-black flex flex-col justify-center h-[30%] items-center gap-5">
                <h1 className="text-3xl">Blockchain Explorer</h1>
                <p>Powered by Alchemy SDK</p>
            </div>

            {/* FORM */}
            <div className="w-[80%] mx-auto mt-10">
                <div className="bg-white p-6 border border-gray-300">
                    <form onSubmit={handleSubmit}>
                        <label
                            for="default-search"
                            className="mb-2 text-sm font-medium text-gray-900 sr-only"
                        >
                            Search
                        </label>
                        <div className="relative">
                            <div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                                <svg
                                    className="w-4 h-4 text-gray-500"
                                    aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 20 20"
                                >
                                    <path
                                        stroke="currentColor"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                                    />
                                </svg>
                            </div>
                            <input
                                type="search"
                                id="default-search"
                                className="block w-full p-4 ps-10 text-sm text-gray-900 border border-gray-100 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Block, hash, transaction, address, etc..."
                                value={searchValue} // Bind the input value to the state
                                onChange={handleChange} // Handle input changes
                                required
                            />
                            <button
                                type="submit"
                                className="text-white absolute end-2.5 bottom-2.5 bg-blue-400 hover:bg-blue-600 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2"
                            >
                                Search
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default HeroSection;
